import(/* webpackMode: "eager" */ "/vercel/path0/ui/app/(app)/ritual/page.tsx");
